import actions from './actions';

const initState = {
  scopes: [],
  loading: false,
  error: '',
  lastUpdated: null,
};

export default function scopesReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_SCOPES:
    case actions.CREATE_SCOPE:
    case actions.UPDATE_SCOPE:
    case actions.DELETE_SCOPE:
      return {
        ...state,
        loading: true,
        error: '',
      };

    case actions.GET_SCOPES_SUCCESS:
      return {
        ...state,
        scopes: action.scopes,
        loading: false,
        error: '',
        lastUpdated: new Date().toISOString(),
      };

    case actions.CREATE_SCOPE_SUCCESS:
      return {
        ...state,
        scopes: [...state.scopes, action.scope],
        loading: false,
        error: '',
      };

    case actions.UPDATE_SCOPE_SUCCESS:
      return {
        ...state,
        scopes: state.scopes.map(scope =>
          scope.id === action.scope.id ? action.scope : scope
        ),
        loading: false,
        error: '',
      };

    case actions.DELETE_SCOPE_SUCCESS:
      return {
        ...state,
        scopes: state.scopes.filter(scope => scope.id !== action.scopeId),
        loading: false,
        error: '',
      };

    case actions.GET_SCOPES_ERROR:
    case actions.CREATE_SCOPE_ERROR:
    case actions.UPDATE_SCOPE_ERROR:
    case actions.DELETE_SCOPE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case actions.CLEAR_SCOPES_ERROR:
      return {
        ...state,
        error: '',
      };

    default:
      return state;
  }
}
